import { makeSchemaNode } from './schemaTree';

function inferType(value) {
  if (value === null) return 'null';
  if (Array.isArray(value)) return 'array';
  if (typeof value === 'object') return 'object';
  if (typeof value === 'boolean') return 'boolean';
  if (typeof value === 'number') return Number.isInteger(value) ? 'integer' : 'number';
  return 'string';
}

function valueToNode(value) {
  const type = inferType(value);
  const node = makeSchemaNode(type);
  if (type === 'null') return node;
  if (type === 'array') {
    if (value.length > 0) {
      node.children = [valueToNode(value[0])];
    }
    return node;
  }
  if (type === 'object') {
    node.children = Object.entries(value).map(([name, childValue]) => {
      const child = valueToNode(childValue);
      child.name = name;
      return child;
    });
    return node;
  }
  node.value = String(value);
  return node;
}

/**
 * Parse pasted JSON into `{ rootType, nodes }` for the schema editor.
 * Accepts a root object or array (arrays become rootType `array` with one item template).
 */
export function parseJsonToSchemaTree(text) {
  const trimmed = String(text ?? '').trim();
  if (!trimmed) throw new Error('Paste JSON to import');
  const parsed = JSON.parse(trimmed);
  if (Array.isArray(parsed)) {
    const template = parsed.length > 0 ? valueToNode(parsed[0]) : makeSchemaNode('string');
    return { rootType: 'array', nodes: [template] };
  }
  if (parsed !== null && typeof parsed === 'object') {
    return {
      rootType: 'object',
      nodes: Object.entries(parsed).map(([name, childValue]) => {
        const child = valueToNode(childValue);
        child.name = name;
        return child;
      }),
    };
  }
  throw new Error('JSON must be an object or array');
}
